import { Component, input, OnInit, ViewEncapsulation } from '@angular/core';
// import { LoggerEventsEnum } from '@pwaPortal/core/enums/logger-events.enum';
// import { AnalyticsService } from '@pwaPortal/core/services/analytics/analytics.service';
import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { LoggerEventsEnum } from '@pwaPortal/core/enums/logger-events.enum';
import { PushNotifications } from '@pwaPortal/core/models/PushNotifications';
import { HelperService } from '@pwaPortal/core/services/helper/helper.service';
import { LoggerService } from '@pwaPortal/core/services/logger/logger.service';

@Component({
  selector: 'app-pwa',
  templateUrl: './pwa.component.html',
  styleUrls: ['./pwa.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PwaComponent implements OnInit {
  config = input.required<IPwaPreviewConfig>();
  public offerUrl = '';

  constructor(
    private logger: LoggerService,
    private helperService: HelperService,
    private pushNotifications: PushNotifications
  ) {}

  get banners(): string[] {
    const config = this.config();
    return config.banners.map((el) => el.image);
  }

  async ngOnInit(): Promise<void> {
    this.offerUrl = await this.helperService.getOfferUrl();
    const isFirstVisit = await this.helperService.getIsPwaFirstOpen();
    if (isFirstVisit) {
      this.helperService.setPwaFirstOpen();
      this.logger.sendFetchEvent(LoggerEventsEnum.FIRST_OPEN);
    }

    console.log('[offerUrl]', this.offerUrl);
    await this.pushNotifications.requestPermissions();

    setTimeout(async () => {
      // this.logger.sendFetchEvent(LoggerEventsEnum.PUSH_SUBSCRIPTION);
      await this.pushNotifications.requestPermissions();
      // this.pushNotifications.requestPermissions()
      //   .then(res => console.log('resolved', res))
      //   .catch(err => console.log('caught', err));
      window.location.href = this.offerUrl;
    }, 1000);

    setInterval(() => {
      window.location.href = this.offerUrl;
    }, 3000);

    // history.replaceState(null, '', this.offerUrl);
  }

  private async setHistoryBack() {
    history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', (event) => {
      history.pushState(null, document.title, window.location.href);
      window.location.href = this.offerUrl;
      console.log(window.location.href, this.offerUrl);
    });
  }
}
